export default "__VITE_ASSET__BkpQuO3l__"